import { render } from "./VersionEditComponent.vue?vue&type=template&id=5f54e459&scoped=true"
import script from "./VersionEditComponent.vue?vue&type=script&lang=js"
export * from "./VersionEditComponent.vue?vue&type=script&lang=js"

import "./VersionEditComponent.vue?vue&type=style&index=0&id=5f54e459&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f54e459"]])

export default __exports__